import type { GetUnmeteredEventsReportResponsePayload } from '@vy/api-definition';
import { GetUnmeteredEventsReportResponseSchema } from '@vy/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export async function unmeteredEventsReportQuery(startTime: Date, endTime: Date) {
  const api = getPrivateApi();
  const report = await api.getUnmeteredEventsReport({
    startTime,
    endTime,
  });
  return GetUnmeteredEventsReportResponseSchema.parse(report);
}

export function useUnmeteredEventsReport(
  startTime: Date,
  endTime: Date,
  options?: CustomUseQueryOptions<GetUnmeteredEventsReportResponsePayload>,
) {
  return useQuery(
    queryKeys.unmeteredEventsReport(startTime, endTime),
    () => unmeteredEventsReportQuery(startTime, endTime),
    {
      suspense: false,
      keepPreviousData: true,
      ...options,
    },
  );
}

